import { AGSRecordBuilder } from "ags/integration/builders/records/abstract-ags-record-builder";
import { AGSSAuthResponseSchema } from "ags/integration/schema/ags-auth-response-schema";
import gameiomModel from "gameiom/model/gameiom-model";
import { DisableSkippingCommand } from "slotworks/commands/setup/disable-skipping-command";
import ReelSpinner from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import autoplayModel from "slotworks/model/autoplay/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay";
import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import builderManager from "slotworks/server/builders/builder-manager";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import AGSRecordUtils from "../ags-record-utils";

export class AuthRecordBuilder extends AGSRecordBuilder implements RecordBuilder {
    public filter(request: any, response: any): boolean {
        if (request instanceof AuthRequestPayload) {
            const authResponse = JSON.parse(response.data) as AGSSAuthResponseSchema;
            const publicState = authResponse.publicState;

            return publicState.recoveredGame === undefined;
        }
        return false;
    }

    public build(gameplay: Gameplay, request: any, response: any) {
        const authResponse = JSON.parse(response.data) as AGSSAuthResponseSchema;
        const publicState = authResponse.publicState;
        const config = authResponse.config;

        BetModel.creditSizes.values = config.denominations;
        BetModel.creditsPerLine.values = config.stakes;
        BetModel.freeBet = this.isFreeBet(config);
        BetModel.setDefaults(config.defaultStake, 0, config.defaultDenomination);
        this.setCreditValues(config);

        GameState.autoDeductStake = !BetModel.freeBet;


        if (gameiomModel.autoplay) {
            autoplayModel.autoplays.values = gameiomModel.autoplay.numberOfRounds.values;
            autoplayModel.autoplays.defaultValue = gameiomModel.autoplay.numberOfRounds.defaultVal;

            autoplayModel.singleWinLimit.values = gameiomModel.autoplay.singleWinLimit.values || [];
            autoplayModel.singleWinLimit.defaultValue = gameiomModel.autoplay.singleWinLimit.defaultVal;

            autoplayModel.lossLimit.values = gameiomModel.autoplay.lossLimit.values || [];
            autoplayModel.lossLimit.defaultValue = gameiomModel.autoplay.lossLimit.defaultVal;
            autoplayModel.lossLimitRequired = gameiomModel.autoplay.lossLimit.lossLimitRequired;

            autoplayModel.totalWinLimit.values = gameiomModel.autoplay.totalWinLimit.values || [];
            autoplayModel.totalWinLimit.defaultValue = gameiomModel.autoplay.totalWinLimit.defaultVal;
        } else {
            autoplayModel.enabled = false;
        }

        ReelSpinner.setMinSpinTime(gameiomModel.minStopDuration);

        if (gameiomModel.minStopDuration > 0 || gameiomModel.disableSpinSkip) {
            DisableSkippingCommand();
        }

        if (gameiomModel.currency === "TKN") {
            gameplay.balance = Math.round(authResponse.platform.balance * 1);
        } else {
            gameplay.balance = Math.round(authResponse.platform.balance * 100);
        }

        if (authResponse.platform.balanceDetails) {
            const multiplier = (gameiomModel.currency === "TKN") ? 1 : 100;
            gameplay.realBalance = Math.round(authResponse.platform.balanceDetails.real * multiplier);
            gameplay.freeBalance = Math.round(authResponse.platform.balanceDetails.bonus * multiplier);
        } else {
            gameplay.realBalance = gameplay.balance;
            gameplay.freeBalance = 0;
        }

        const dummyRecord = new SpinRecord();

        dummyRecord.results = builderManager.buildResult(dummyRecord, publicState);

        dummyRecord.grid = AGSRecordUtils.convertreelsToSlotworksGrid(authResponse.publicState.startingSymbols);

        return [dummyRecord] as Record[];
    }
}

export default new AuthRecordBuilder();
